import React from "react";
import { StyledButton, StyledHCard, StyledService } from "../components/Styles";

import CostEffective from "../components/Styles/assets/Graphics/CostEffective2.webp";
import EasytoUse from "../components/Styles/assets/Graphics/EasytoUse.webp";
import SEOFriendly from "../components/Styles/assets/Graphics/SEOFriendly.webp";
import OnlineSales from "../components/Styles/assets/Graphics/OnlineSales.webp";
import Customizable from "../components/Styles/assets/Graphics/Customizable.webp";
import Integration from "../components/Styles/assets/Graphics/Integration.webp";

import img13 from "../components/Styles/assets/img13.webp";
import { Link } from "react-router-dom";
import Consultation from "../components/Consultation";

import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";

function WordpressDesign() {
  const { i18n, t } = useTranslation();

  const advantages = [
    "costEffective",
    "easyToUse",
    "seoFriendly",
    "onlineSales",
    "customizable",
    "integration"
  ];

  const icons = {
    costEffective: CostEffective,
    easyToUse: EasytoUse,
    seoFriendly: SEOFriendly,
    onlineSales: OnlineSales,
    customizable: Customizable,
    integration: Integration
  };

  return (
    <StyledService.Container>
      <StyledService.Hero>
        <StyledService.Content>
          <StyledService.Title lang={i18n.language}>{t("wordpress.title")}</StyledService.Title>
          <StyledService.Description>{t("wordpress.description")}</StyledService.Description>
          <Link to={`/${i18n.language}/${slugs.contact[i18n.language]}`}>
            <StyledButton.Main>{t("wordpress.cta")}</StyledButton.Main>
          </Link>
        </StyledService.Content>
        <StyledService.ImageContainer>
          <img
            src={img13}
            alt={t("wordpress.title")}
            style={{ width: "100%", height: "auto", borderRadius: "10px" }}
          />
        </StyledService.ImageContainer>
      </StyledService.Hero>

      <Consultation />

      <StyledService.H3 lang={i18n.language}>{t("wordpress.advantagesTitle")}</StyledService.H3>

      <StyledHCard.Container>
        {advantages.map((key) => (
          <StyledHCard.SingleCard key={key}>
            <StyledHCard.IconContainer>
              <img src={icons[key]} alt={key} />
            </StyledHCard.IconContainer>
            <StyledHCard.Content>
              <StyledHCard.Title>{t(`wordpress.advantages.${key}.title`)}</StyledHCard.Title>
              <StyledHCard.Description>{t(`wordpress.advantages.${key}.desc`)}</StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>

      <Consultation />
    </StyledService.Container>
  );
}

export default WordpressDesign;